
import { createTelemetry, logs as wpLogs, metrics as wpMetrics, trace } from '@web-platform/telemetry'

function isConfigEnabled(configVal, localEnvVal) {
  if (process.env?.NODE_ENV === 'development') {
    return localEnvVal;
  }
  return configVal === true || configVal === 'true';
}

const CONFIG = window?.['inject']?.['CONFIG'];
export const ENABLE_MONITORING = isConfigEnabled(CONFIG?.TELEMETRY_ENABLE, false);
const BASE_URL = CONFIG?.TELEMETRY_BASE_URL ?? 'https://hermes-ingest.moniepointinc.com/v1';
const SERVICE_NAME = CONFIG?.TELEMETRY_SERVICE_NAME ?? 'moniepoint-frontoffice-web';
const DEBUG_MODE = isConfigEnabled(CONFIG?.TELEMETRY_DEBUG_MODE, true);
const DEV_MODE =  isConfigEnabled(CONFIG?.TELEMETRY_DEV_MODE, true);
const ENVIRONMENT = CONFIG?.FO_ENVIRONMENT ?? 'local';
const TELEMETRY_INTERVAL_MILLIS = CONFIG?.TELEMETRY_INTERVAL_MILLIS ?? 20_000;

export const { logging, metrics, tracing } = createTelemetry({
  collectorBaseUrl: BASE_URL,
  serviceName: SERVICE_NAME,
  showInBrowserConsole: DEBUG_MODE,
  devMode: DEV_MODE,
  environment: ENVIRONMENT,
  exportIntervalsMillis: Number(TELEMETRY_INTERVAL_MILLIS),
});

if (!ENABLE_MONITORING) {
  wpMetrics.disable()
  wpLogs.disable()
  trace.disable()
}

export const logger = logging.setup('logs');
